/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
// tailwind
import './src/styles/global.scss';
// sass
import './src/styles/index.scss';

import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import React from 'react';

// import { useEventListener } from './src/hooks';

if (process.env.GATSBY_APP_DEPLOY_ID !== 0) {
  Bugsnag.start({
    apiKey: process.env.GATSBY_BUGSNAG_API_KEY,
    appVersion: process.env.GATSBY_APP_DEPLOY_ID,
    plugins: [new BugsnagPluginReact(React)],
    releaseStage: process.env.GATSBY_APP_CONTEXT || process.env.NODE_ENV,
  });
}

export const wrapRootElement = ({ element }) => {
  if (Bugsnag.isStarted()) {
    const ErrorBoundary = Bugsnag.getPlugin('react');
    // eslint-disable-next-line react/jsx-filename-extension
    return <ErrorBoundary>{element}</ErrorBoundary>;
  }
  return element;
};

export const onInitialClientRender = () => {
  window.scrollTo(0, 0);
};

export const onRouteUpdate = () => {
  const readyStateMonitor = setInterval(() => {
    const { readyState } = window.document;
    if (readyState === 'complete') {
      clearInterval(readyStateMonitor);

      // window.dataLayer.push({
      //   event: 'ga4_initialize',
      // });
      // useEventListener();
    }
  }, 200);
};

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  const { pathname } = location;
  // list of routes for the scroll-to-top-hook
  const keepScroll = [];
  // if the new route is part of the list above, scroll to top (0, 0)

  if (keepScroll.indexOf(pathname) === -1) {
    window.scrollTo(0, 0);
  }

  return false;
};
